import script from "./Trainer.vue?vue&type=script&setup=true&lang=js"
export * from "./Trainer.vue?vue&type=script&setup=true&lang=js"

import "./Trainer.vue?vue&type=style&index=0&id=1f2e6110&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2e6110"]])

export default __exports__